import Link from './Link';

export default Link;
export { Link };
